$(function() {
    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var email = $('.email-dialog');
    var form = $('.form-email-signup-tool');
    var form_errors = $('.form-errors');

    $(document).on('click', '.form-email-signup-tool button[type=submit]', function(e) {
        e.preventDefault();
        if (regex.test(email.val())) {
            form.submit();
        } else {
            email.addClass('err');
            form_errors.show();
        }
    });

});
